import { IonContent, IonHeader, IonModal } from '@ionic/react'
import React, { useEffect, useMemo, useState } from 'react'
import { Input } from '@cps'
import { useDebounce } from '@dt/fe-utils'
import { useHistoryNew, modalLayer, toastLayer } from '@utils'
import { observer } from 'mobx-react'
import { menuMobx, cartMobx, storeMobx } from 'restaurant'
import WaterfallItem from '../../components/WaterfallItem'
import { WaterfallProductItem, WaterfallActivityItem } from './components'
import { ActivityModal } from '../'
import hotProductMobx from 'mobx/menu/hotProduct.mobx'
import { voiceServiceMobx } from '@mobxStore'
import productStyleController from '@ctrls/productStyleController'
import { wxConfigG } from 'controllers/third'
import CashierController from '@ctrls/cashierController'
import NoSearchImg from '@img/no_search.png'

import { mpc } from '@dt/mmg-sdk'
import './index.scss'

type TSearchType = 'product' | 'activity'
interface ISearchModalProps {
  reject?: (flag?: any) => void;
  resolve?: (product: any) => void;
}

// 存储计算结果
const lineToResult = {}

const SearchModal: React.FC<ISearchModalProps> = (props) => {
  const history = useHistoryNew()
  const { productNoToCntMap } = cartMobx.cartResult
  const { searchList: resultList, isOpenSearchActivity, isVoiceSearchEnable } = voiceServiceMobx
  const isProduct = useMemo(() => {
    return !resultList.length || ['FixedCombo', 'OptionalCombo', 'product'].includes(resultList[0].type)
  }, [resultList])

  const handleSelectProduct = (result) => {
    if (isProduct) {
      props.resolve(result)
      // setResultList([])
      voiceServiceMobx.setSearchList([])
    } else {
      const { isDisable, disableReason } = result
      if (!isDisable) {
        modalLayer(ActivityModal, {
          data: result
        }).then((product: any) => {
          CashierController.handleProductToCart({
            type: 'add',
            product,
            isAddProduct: true
          })
        }).catch(() => {
        })
      } else {
        const errStr = i18n.t(`activity.${disableReason === 'time' ? 'activityNotStart' : 'onlyForMember'}`)
        toastLayer.info({
          content: errStr,
          duration: 1000
        })
      }
    }
  }

  const handleCancelSearch = () => {
    props.reject()
    // setResultList([])
    voiceServiceMobx.setSearchList([])
  }

  useEffect(() => {
    hotProductMobx.init()
  }, [])

  const handleMicrophoneClick = (e) => {
    e.preventDefault()
    const info = history.getRouteInfo()
    props.reject('microphone')
  }

  const handleSearch = useDebounce(async (e) => {
    const res = await voiceServiceMobx.contentMatch(e.target.value)
    const { content: list, info } = res
    if (list.filter(item => item.content_type === 'call_activity').length) {
      if (isOpenSearchActivity) {
        const act = await mpc.refreshActivity()
        const availableActsMap = await voiceServiceMobx.getActsList(act)
        // setResultList(availableActsMap)
        voiceServiceMobx.setSearchList(availableActsMap)
        return
      }
      voiceServiceMobx.setSearchList([])
    } else {
      // setSearchType('product')
      const products = list.filter(item => item.content_type === 'product')
      const searchedProducts = voiceServiceMobx.getSearchedProducts(products)
      // setResultList(searchedProducts)
      voiceServiceMobx.setSearchList(searchedProducts)
    }
  }, 500)
  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })
  // const [height, setHeight] = useState(420)
  const hashProduct = useMemo(() => {
    return resultList.map(p => p.no || p.contextId).join('')
  }, [resultList])
  const calcWaterfall = () => {
    const payload = productStyleController.waterfall(resultList, false, isProduct ? 'no' : 'contextId')
    if (payload) {
      const { styleMap, height } = payload
      lineToResult[hashProduct] = payload
      setProductStyleMap(styleMap)
      // setHeight(height)
    } else {
      setTimeout(() => {
        calcWaterfall()
      }, 300)
    }
  }
  useEffect(() => {
    if (resultList.length && hashProduct) {
      if (lineToResult[hashProduct]) {
        setProductStyleMap(lineToResult[hashProduct].styleMap)
        // setHeight(lineToResult[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 50)
      }
    }
  }, [hashProduct])
  useEffect(() => {
    window.addEventListener(window.onorientationchange ? 'orientationchange' : 'resize', () => {
      calcWaterfall()
    }, false)
  }, [])

  return (
    <IonModal
      cssClass='search-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='search-input-wrapper'>
          <span onClick={handleCancelSearch} className='btn-back'>
            <i className='iconfont icon-BACK-12x'></i>
          </span>
          <Input
            icon='iconfont icon-search'
            placeholder={i18n.t('menu.search_product')}
            value={menuMobx.searchKey || ''}
            onChange={(e) => {
              menuMobx.setSearchKey(e.target.value)
              if (![undefined, null, ''].includes(String(e.target.value).trim())) {
                handleSearch(e)
              } else {
                // setResultList([])
                voiceServiceMobx.setSearchList([])
              }
            }}
            autoFocus
          />
          {
            isVoiceSearchEnable ? (
              <span className='btn-microphone' onClick={handleMicrophoneClick}>
                <i className='iconfont icon-vioce_microphone'></i>
              </span>
            ) : <></>
          }
        </div>
      </IonHeader>
      <IonContent className='menu-search-content'>
        {!!(!menuMobx.searchKey && hotProductMobx.HotViewProduct.length) && (
          <div className='hot-product-wrapper'>
            <h5>{i18n.t('menu.hot_product')}</h5>
            {hotProductMobx.HotViewProduct.map((product) => {
              return (
                <div
                  className='simple-product'
                  onClick={() => handleSelectProduct(product)}
                  key={product.no}
                >
                  {product.name}
                </div>
              )
            })}
          </div>
        )}
        <div className='search-product-split'></div>
        {menuMobx.searchKey && (
          <div className='search-product-list search-waterfall-template'>
            {
              resultList.length ? (
                resultList.map((result) => {
                  const id = isProduct ? result.no : result.contextId
                  return (
                    <WaterfallItem
                      key={id}
                      lazy={false}
                      style={productStyleMap[id]}
                      id={'searchproduct' + id}
                      onClick={() => handleSelectProduct(result)}
                    >
                      {
                        isProduct ? (
                          <WaterfallProductItem
                            product={result}
                            count={productNoToCntMap?.[id] || 0}
                          />
                        ) : (
                          <WaterfallActivityItem
                            data={result}
                          />
                        )
                      }
                    </WaterfallItem>
                  )
                })
              ) : (
                <div className='empty-info'>
                  <img src={NoSearchImg} alt='' className='empty-info-pic' />
                  <p>{i18n.t('menu.no_search_product1')}</p>
                </div>
              )
            }
          </div>
        )}
      </IonContent>
    </IonModal>
  )
}

export default observer(SearchModal)
